<div class="container-fluid vh-100 login-page-container">
  <div class="row h-100">

    <!-- ==================== LEFT SIDE – IMAGE ==================== -->
    <div class="col-md-6 d-none d-md-flex align-items-center justify-content-center bg-light p-0 overflow-hidden">
      <div class="login-vector-background"></div>

      <img src="assets/images/loginImage.png"
           alt="Application Visual"
           class="img-fluid"
           style="object-fit: contain">

      <div class="lms-logo-box">
        <!-- <h1 class="lms-logo-text">LMS</h1> -->
      </div>
    </div>

    <!-- ==================== RIGHT SIDE – FORM ==================== -->
    <div class="col-md-5 flex-column justify-content-center login-right-column">

      <!-- Heading -->
      <h1 class="fw-bold login-heading mb-0">Add New User</h1>
      <p class="text-muted mt-1 login-subheading">Fill in the details to create a user account.</p>

      <!-- ==================== ADD USER FORM ==================== -->
      <form [formGroup]="addUserForm" (ngSubmit)="onSubmit()" class="mt-4">

        <!-- Username -->
        <div class="email-input mb-4">
          <label for="username" class="email-label">Username <span class="text-danger">*</span></label>
          <input id="username"
                 type="text"
                 formControlName="username"
                 class="form-control custom-input"
                 placeholder="john_doe"
                 required>
          <div class="invalid-feedback"
               *ngIf="addUserForm.get('username')?.hasError('required') && addUserForm.get('username')?.touched">
            Username is required.
          </div>
        </div>

        <!-- Email -->
        <div class="email-input mb-4">
          <label for="email" class="email-label">Email <span class="text-danger">*</span></label>
          <input id="email"
                 type="email"
                 formControlName="email"
                 class="form-control custom-input"
                 placeholder="john@example.com"
                 required>
          <div class="invalid-feedback"
               *ngIf="addUserForm.get('email')?.hasError('required') && addUserForm.get('email')?.touched">
            Email is required.
          </div>
          <div class="invalid-feedback"
               *ngIf="addUserForm.get('email')?.hasError('email') && addUserForm.get('email')?.touched">
            Please enter a valid email address.
          </div>
        </div>

        <!-- First Name -->
        <div class="email-input mb-4">
          <label for="firstName" class="email-label">First Name</label>
          <input id="firstName"
                 type="text"
                 formControlName="firstName"
                 class="form-control custom-input">
        </div>

        <!-- Last Name -->
        <div class="email-input mb-4">
          <label for="lastName" class="email-label">Last Name</label>
          <input id="lastName"
                 type="text"
                 formControlName="lastName"
                 class="form-control custom-input">
        </div>

        <!-- Password -->
        <div class="password-input mb-4">
          <label for="password" class="password-label">Password <span class="text-danger">*</span></label>
          <input id="password"
                 type="password"
                 formControlName="password"
                 class="form-control custom-input"
                 required>
          <div class="invalid-feedback"
               *ngIf="addUserForm.get('password')?.hasError('required') && addUserForm.get('password')?.touched">
            Password is required.
          </div>
          <div class="invalid-feedback"
               *ngIf="addUserForm.get('password')?.hasError('minlength') && addUserForm.get('password')?.touched">
            Password must be at least 8 characters long.
          </div>
        </div>

        <!-- Email Verified -->
        <div class="mb-4">
          <label class="d-flex align-items-center">
            <input type="checkbox" formControlName="emailVerified" class="me-2">
            <span class="email-label">Email verified</span>
          </label>
        </div>

        <!-- Group -->
        <div class="mb-4">
            <label class="email-label">Group</label>
                <select formControlName="groupName" class="form-select custom-input">
                    <option [ngValue]="null">— None —</option>
                    <option *ngFor="let g of groups" [value]="g.name">{{ g.name }}</option>
                </select>
        </div>

        <!-- Client Roles (multi-select) -->
        <div class="mb-4">
          <label class="email-label">Client Roles (hold Ctrl/Cmd)</label>
            <select multiple formControlName="roleNames" class="form-select custom-input" size="3">
                <option *ngFor="let r of roles" [value]="r.name">{{ r.name }}</option>
            </select>
        </div>

        <!-- Submit Button -->
        <button type="submit"
                class="btn btn-primary w-100"
                [disabled]="addUserForm.invalid || isLoading">
          {{ isLoading ? 'Adding User...' : 'Add User' }}
        </button>
      </form>

      <!-- Success / Error Messages -->
      <div *ngIf="successMessage" class="alert alert-success mt-4" role="alert">
        {{ successMessage }}
      </div>
      <div *ngIf="errorMessage" class="alert alert-danger mt-4" role="alert">
        <strong>Error:</strong> {{ errorMessage }}
        <small *ngIf="errorDetails" class="d-block mt-1 text-muted">
          {{ errorDetails }}
        </small>
      </div>

    </div> <!-- End Right Column -->
  </div> <!-- End Row -->
</div> <!-- End Container -->